module.exports = __webpack_public_path__ + "static/chatons-7b6ec82aacd7ef3317c3027d3645c69e.svg";